import * as actionTypes from "../actions/actionTypes";

const initialState = {
    show: false,
    message: null,
    severity: null,
};

const showSnackbar = (state, action) => {
    return {
        ...state,
        show: true,
        message: action.message,
        severity: action.severity,
    };
};

const hideSnackbar = (state, action) => {
    return {
        ...state,
        show: false,
    };
};

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.SHOW_SNACKBAR:
            return showSnackbar(state, action);
        case actionTypes.HIDE_SNACKBAR:
            return hideSnackbar(state, action);
        default:
            return state;
    }
};

export default reducer;
